(function($) {
	$(document).ready(function () {
		$('.nav-open').on('click', function(event) {
			event.preventDefault();
			$('body').css('overflow', 'hidden');
			$('#page').addClass('blur');
			$('#nav').addClass('open');
		});
	
		$('.nav-close').on('click', function(event) {
			event.preventDefault();
			$('#nav').removeClass('open');
			$('#page').removeClass('blur');
			$('body').css('overflow', 'auto');
		});

		// // Toggle mega menu on mobile
		// $('.dropdown-toggle-element').on('click', function(e) {
		// 	e.preventDefault();
		// 	e.stopPropagation();
			
		// 	var $this = $(this);
		// 	var $parent = $this.closest('li');
		// 	const $wrapper = $parent.find('.mega-menu-wrapper');
			
		// 	$this.toggleClass('active');
		// 	$wrapper.toggleClass('open');

		// 	// Close mega menus when clicking outside
		// 	const closeMegaMenu = function (event) {
		// 		if (!$parent.is(event.target) && $parent.has(event.target).length === 0) {
		// 			$this.removeClass('active');
		// 			$wrapper.removeClass('open');
		// 			$(event.target).off('click', closeMegaMenu);
		// 		}
		// 	};
		// 	$(document).on('click.mega-menu-close', closeMegaMenu);

		// });

	});
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
	const megaMenuItems = document.querySelectorAll('.mega-menu-item');
	const megaMenus = document.querySelectorAll('.mega-menu-viewport');
	const megaMenusContainer = document.querySelector(`.mega-menus-container`);
	
	// For each mega menu item
	megaMenuItems.forEach(item => {
		const itemId = item.classList.toString().match(/mega-menu-item-(\d+)/)[1];
		const megaMenu = document.querySelector(`.mega-menu-${itemId}`);
		const itemLink = item.querySelector('a');
		
		if(megaMenu) {
			// Show mega menu on hover
			item.addEventListener('mouseenter', () => {
				closeAllMegaMenus();
				megaMenusContainer && megaMenusContainer.classList.add('open');
				itemLink.classList.add('active');
				megaMenu.style.display = 'block';
			});
			
			// Allow hovering over mega menu
			megaMenu.addEventListener('mouseenter', () => {
				megaMenusContainer && megaMenusContainer.classList.add('open');
				itemLink.classList.add('active');
				megaMenu.style.display = 'block';
			});
			
			// Hide on mouse leave
			megaMenu.addEventListener('mouseleave', () => {
				closeAllMegaMenus();
			});
		}
	});
	
	// Hide when mouse leaves menu item
	document.addEventListener('mouseover', function(e) {
		if (!e.target.closest('header') && !e.target.closest('.mega-menu-item') && !e.target.closest('.mega-menu-viewport')) {
			closeAllMegaMenus();
		}
	});
	
	function closeAllMegaMenus() {
		megaMenusContainer && megaMenusContainer.classList.remove('open');
		megaMenus.forEach(menu => {
			menu.style.display = 'none';
			document.querySelectorAll('.mega-menu-item a.active').forEach((el) => {
				el.classList.remove('active');
			})
		});
	}
});